import * as React from 'react';
import { HelpView } from './Help.view';

export type HelpType = JSX.Element;

export const HelpController = (): HelpType => {
  // Put All your methods and logic here
  return <HelpView />;
};
